import RequiredBadge from 'components/RequiredBadge';
import React, { useContext } from 'react';
import {
  Box, Breadcrumbs, FormControl, Typography,
} from '@mui/material';
import { modifierContext } from '../../ModifierProvider';
import {
  getModifierMinSelections,
  getModifierSelectionsText,
  isAutoApplied,
  isMultiSelect,
} from '../../utils';
import MultiSelectModifier from './MultiSelectModifier';
import SingleSelectModifier from './SingleSelectModifier';

function Modifier({ modifier, showModifiersError }) {
  const { hasSelectionsSatisfied, parent } = useContext(modifierContext);
  const isSatisfied = hasSelectionsSatisfied(modifier);
  const isRequired = getModifierMinSelections(modifier) > 0;
  const Control = isMultiSelect(modifier)
    ? MultiSelectModifier
    : SingleSelectModifier;
  const disabled = isAutoApplied(modifier);

  return (
    <FormControl sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ mb: 1 }}>
          {parent && (
            <Breadcrumbs aria-label="breadcrumb">
              <Typography color="text.secondary" variant="caption">
                {parent.modifier.title}
              </Typography>
              <Typography color="text.secondary" variant="caption">
                {parent.option.title}
              </Typography>
            </Breadcrumbs>
          )}

          <Typography variant="title-lg">
            {modifier.title}
          </Typography>
          {!isAutoApplied(modifier) && (
            <Typography variant="body-overline" fontWeight={isSatisfied ? 500 : 700} color={(showModifiersError && !isSatisfied) ? 'error.main' : 'text.secondary'}>
              {getModifierSelectionsText(modifier)}
            </Typography>
          )}
        </Box>
        {isRequired && <RequiredBadge isSatisfied={isSatisfied || isAutoApplied(modifier)} needSelection={showModifiersError} />}
      </Box>

      <Control modifier={modifier} disabled={disabled} />
    </FormControl>
  );
}

export default Modifier;
